export default __webpack_public_path__ + "static/media/image-removed-img.bfc1e8e6.svg";